import { useMemo } from 'react'
import Visualization from './Visualization'
import { OFFICIAL_USE_ONLY_LABEL } from '../../common/utils/constants'
import { isOfficialUse } from '../../common/utils/helper'

const IndicatorDetails = ({
  subTopic,
  setLoadingStates,
  loadingStates,
  subTopicIndex,
}) => {
  const selectedIndicator = useMemo(
    () => subTopic.indicators.find((obj) => obj.isSelected),
    [subTopic.indicators]
  )

  return (
    <div
      className="swiper-wrapper"
      id="swiper-wrapper-a82b45bb8cda9f10f"
      aria-live="polite"
    >
      {selectedIndicator && (
        <div key={`${selectedIndicator.id}-visualization`}>
          <Visualization
            key={`${selectedIndicator.id}-${selectedIndicator.datasetId}`}
            selectedIndicator={selectedIndicator}
            isLoading={loadingStates[selectedIndicator.id]}
            onLoad={() =>
              setLoadingStates((prev) => ({
                ...prev,
                [selectedIndicator.id]: false,
              }))
            }
            subTopicIndex={subTopicIndex}
            uniqueId={`${subTopic?.id}-${selectedIndicator.id}`}
          />
          {isOfficialUse(selectedIndicator?.data_classification) && (
            <p className="tui_official_use">{OFFICIAL_USE_ONLY_LABEL}</p>
          )}
        </div>
      )}
    </div>
  )
}

export default IndicatorDetails
